import { Checkbox, FormControl, Grid, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, Typography } from '@mui/material';
import CustomButton from 'components/shared/Buttons/CustomButton';
import theme from 'components/utils/theme';
import { useState } from 'react';
import styles from '../Account.module.scss';
import { osVersionOptions } from './helper';
import { sendUpdateBinaryRequest } from '../../../../redux/saga/socket';
import { useSelector } from 'react-redux';
import { authActions } from '../../../../redux/slice/auth.slice';
import toast from 'react-hot-toast';


const SystemUpdates = () => {
  const [selectedVersions, setSelectedVersions] = useState([]);
  const currentUser = useSelector(authActions.selectors.getCurrentUser)

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedVersions(value);
  };

  const handleDeploy = async () => {
    console.log('Deploying versions:', selectedVersions);
    if (!selectedVersions?.length) {
      return toast.error("Please select at least one version");
    }
    sendUpdateBinaryRequest(selectedVersions, currentUser?.orgId);
    await new Promise(resolve => setTimeout(resolve, 1000));
    toast.success("Update request received. Devices will be updated shortly.");
  };
  

  return (
    <Grid mt={2}  gap={2} container  className={styles.accountCard}>
      <Grid item xs={12}>
        <Typography variant="subtitle1" fontWeight="bold">
          Update System Software
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <FormControl fullWidth>
          <InputLabel id="version-select-label">Select Versions</InputLabel>
          <Select
            labelId="version-select-label"
            multiple
            value={selectedVersions}
            onChange={handleChange}
            input={<OutlinedInput label="Select Versions" />}
            renderValue={(selected) => selected.join(', ')}
          >
            {osVersionOptions.map((version) => (
              <MenuItem key={version} value={version}>
                <Checkbox checked={selectedVersions.indexOf(version) > -1} />
                <ListItemText primary={version} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid item display={"flex"} justifyContent={"flex-end"} xs={12}>
        <CustomButton
          padding={"0px 50px"}
          color={theme.palette.background.default}
          bgColor={theme.palette.primary.main}
          hover={theme.palette.info.main}
          label={"Apply Update"}
          type={"submit"}
          onClick={handleDeploy}
        />
      </Grid>
    </Grid>
  );
};

export default SystemUpdates;
